if (!window.__hoverCycleInit) {
  window.__hoverCycleInit = true;

  var FRAME_INTERVAL = 1000;

  function startCycle(el) {
    if (el.__hoverCycleTimer) return;
    var frames = el.querySelectorAll('[data-hover-frame]');
    if (!frames.length) return;
    el.classList.add('is-cycling');
    var i = 0;
    frames[i].classList.add('is-active');
    el.__hoverCycleTimer = setInterval(function () {
      frames[i].classList.remove('is-active');
      i = (i + 1) % frames.length;
      frames[i].classList.add('is-active');
    }, FRAME_INTERVAL);
  }

  function stopCycle(el) {
    if (el.__hoverCycleTimer) {
      clearInterval(el.__hoverCycleTimer);
      el.__hoverCycleTimer = null;
    }
    el.classList.remove('is-cycling');
    var active = el.querySelectorAll('[data-hover-frame].is-active');
    for (var i = 0; i < active.length; i++) {
      active[i].classList.remove('is-active');
    }
  }

  function bindElement(el) {
    if (el.hasAttribute('data-hover-cycle-bound')) return;
    el.setAttribute('data-hover-cycle-bound', '');
    el.addEventListener('mouseenter', function () {
      startCycle(el);
    });
    el.addEventListener('mouseleave', function () {
      stopCycle(el);
    });
    el.addEventListener('focusin', function () {
      startCycle(el);
    });
    el.addEventListener('focusout', function () {
      stopCycle(el);
    });
  }

  function initHoverCycleElements() {
    var elements = document.querySelectorAll('[data-hover-cycle]');
    for (var i = 0; i < elements.length; i++) {
      bindElement(elements[i]);
    }
  }

  initHoverCycleElements();
}
